<template>
  <div key="video-panel"
       class="bg-black flex justify-center items-center">
    <div class="video-player">
      <video ref="videoPlayer" class="video-js" controls></video>
    </div>
  </div>
</template>

<script>
import videojs from 'video.js';
import {stageParser, /*getRStage, getECode*/} from "@/utils/auth-data";
import {config} from "@/utils/upload";

export default {
  name: "MainPanelVdo",
  props: [
    'currentVdoSetTopic',
  ],
  data() {
    return {
      player: null,
      videoMimeType: "application/x-mpegURL",
      isPlaying: false,
      counter: 0,
      timer: null,
      e_code: !localStorage.getItem("rsc") ? null : JSON.parse(localStorage.getItem("rsc")).e_code,
      r_stage: !localStorage.getItem("rsc") ? null : JSON.parse(localStorage.getItem("rsc")).r_stage,
    }
  },
  watch: {
    currentVdoSetTopic(val) {
      if (this.player) {
        this.changeVideoSrc(val);
      } else {
        if (this.currentVdoSetTopic) {
          this.setUpVideoJs(this.currentVdoSetTopic);
        }
      }
    },
  },
  methods: {
    setUpVideoJs() {
      const _this = this;

      _this.player = videojs(this.$refs.videoPlayer, {
        sources: this.generateVdoSource(this.currentVdoSetTopic),
        controlBar: {
          playbackRateMenuButton: true,
          pictureInPictureToggle: false,
        },
        autoplay: true,
        fluid: false,
        controls: true,
        hotkeys: true,
        responsive: true,
        aspectRatio: '16:9',
        playbackRates: [1, 1.5, 2],
        preload: 'metadata',
        nativeControlsForTouch: true,
        nativeControls: true,

      }, function onPlayerReady() {
        _this.$refs.videoPlayer.controls = true;
      });
    },
    generateVdoSource(currentVdoSetTopic) {
      return [
        {
          src: this.getVideoSrc(currentVdoSetTopic),
          type: this.videoMimeType,
        }
      ]
    },
    getVideoSrc(currentVdoSetTopic) {
      const STREAMING_APP = `${this.e_code}_${stageParser(this.r_stage)}_video-material`;
      const vdoStreamPath = currentVdoSetTopic ? currentVdoSetTopic.vdoStreamPath : '';
      return `${config.streamServer}/definst/${STREAMING_APP}/mp4:${vdoStreamPath}/playlist.m3u8`;
    },
    changeVideoSrc(currentVdoSetTopic) {
      //change video
      if (currentVdoSetTopic) {
        this.player.src(
          {
            src: this.getVideoSrc(currentVdoSetTopic),
            type: this.videoMimeType,
          },
        );
      }
    },
  },
  mounted() {
    if (!this.player) {
      this.setUpVideoJs();
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
    }
  }
}
</script>

<style lang="scss">

.video-player {
  width: 100% !important;
  height: auto !important;
  max-height: calc(100vh - 180px) !important;
  background: #22292f;
  overflow: hidden;
  position: relative;

  & .video-js {
    width: 100% !important;
    height: auto !important;
    padding-top: 0 !important;

    & video {
      width: 100% !important;
      height: auto !important;
      max-height: 100vh;
      @media only screen and (min-height: 600px) {
        max-height: calc(100vh - 200px);
      }
    }

    & .vjs-control-bar {
      display: none;
      z-index: 999999;
      position: absolute;
    }

    & .vjs-loading-spinner {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 100%;
      // background: #0000005c;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      display: none;
    }

    & .vjs-big-play-button {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      width: 200px;
      height: 200px;
      background: #0000005c;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      border-radius: 50%;
      border-width: 5px;
      border-color: #ffffff5e;
      display: none;
    }

    & .vjs-control-bar {
      display: none;
      position: absolute;
      bottom: 0;
      height: 40px;
      background: red;
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      display: none;

      & > .vjs-control {
        margin: 10px;
      }

    }

    & .vjs-poster {
      display: none;
    }

    & .vjs-text-track-display {
      display: none;
    }

    & .vjs-error-display {
      display: none;
    }

    & .vjs-modal-dialog {
      display: none;
    }
  }
}
</style>
